var map = {
	"./roleAdmin0.png": "AH8Z",
	"./roleAdmin1.png": "JX0X"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Aj3p";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/left ^\.\/roleAdmin.*\.png$
// module id = Aj3p
// module chunks = 3